import { LANGUAGE } from '@common/constants/global.constants'
import { CertificationCourse } from '@common/enums/certification.enums'
import {
	CompanyCountry,
	CompanyType
} from '@common/enums/company.enums'
import { Status } from '@common/enums/global.enums'
import { Route } from '@config/routes/routes.enums'
import { flatten } from 'flat'

const messages = {
	global: {
		buttons: {
			apply: 'Anwenden',
			cancel: 'Abbrechen',
			clear: 'Löschen',
			confirm: 'Bestätigen',
			create: 'Erstellen',
			delete: 'Löschen',
			download: 'Herunterladen',
			export: 'Exportieren',
			update: 'Aktualisieren'
		},
		enums: {
			certificationCourse: {
				[CertificationCourse.HALF_DAY_SBEX_HIGH_PRESSURE]: 'Half-day SBEx High Pressure',
				[CertificationCourse.HALF_DAY_SBEX_LOW_PRESSURE]: 'Half-day SBEx Low Pressure',
				[CertificationCourse.SBEX_HIGH_PRESSURE]: 'SBEx High Pressure',
				[CertificationCourse.SBEX_LOW_PRESSURE]: 'SBEx Low Pressure',
				[CertificationCourse.SBEX_MPI]: 'SBEx Mpi',
				[CertificationCourse.SBEX_PHASTITE]: 'SBEx Phastite'
			},
			companyCountry: {
				[CompanyCountry.AFGHANISTAN]: 'Afghanistan',
				[CompanyCountry.ALBANIA]: 'Albanien',
				[CompanyCountry.ALGERIA]: 'Algerien',
				[CompanyCountry.ANDORRA]: 'Andorra',
				[CompanyCountry.ANGOLA]: 'Angola',
				[CompanyCountry.ANTIGUA_AND_BARBUDA]: 'Antigua und Barbuda',
				[CompanyCountry.ARGENTINA]: 'Argentinien',
				[CompanyCountry.ARMENIA]: 'Armenien',
				[CompanyCountry.AUSTRALIA]: 'Australien',
				[CompanyCountry.AUSTRIA]: 'Österreich',
				[CompanyCountry.AZERBAIJAN]: 'Aserbaidschan',
				[CompanyCountry.BAHAMAS]: 'Bahamas',
				[CompanyCountry.BAHRAIN]: 'Bahrain',
				[CompanyCountry.BANGLADESH]: 'Bangladesch',
				[CompanyCountry.BARBADOS]: 'Barbados',
				[CompanyCountry.BELARUS]: 'Belarus',
				[CompanyCountry.BELGIUM]: 'Belgien',
				[CompanyCountry.BELIZE]: 'Belize',
				[CompanyCountry.BENIN]: 'Benin',
				[CompanyCountry.BHUTAN]: 'Bhutan',
				[CompanyCountry.BOLIVIA]: 'Bolivien',
				[CompanyCountry.BOSNIA_AND_HERZEGOVINA]: 'Bosnien und Herzegowina',
				[CompanyCountry.BOTSWANA]: 'Botsuana',
				[CompanyCountry.BRAZIL]: 'Brasilien',
				[CompanyCountry.BRUNEI]: 'Brunei',
				[CompanyCountry.BULGARIA]: 'Bulgarien',
				[CompanyCountry.BURKINA_FASO]: 'Burkina Faso',
				[CompanyCountry.BURUNDI]: 'Burundi',
				[CompanyCountry.CABO_VERDE]: 'Kap Verde',
				[CompanyCountry.CAMBODIA]: 'Kambodscha',
				[CompanyCountry.CAMEROON]: 'Kamerun',
				[CompanyCountry.CANADA]: 'Kanada',
				[CompanyCountry.CENTRAL_AFRICAN_REPUBLIC]: 'Zentralafrikanische Republik',
				[CompanyCountry.CHAD]: 'Tschad',
				[CompanyCountry.CHILE]: 'Chile',
				[CompanyCountry.CHINA]: 'China',
				[CompanyCountry.COLOMBIA]: 'Kolumbien',
				[CompanyCountry.COMOROS]: 'Komoren',
				[CompanyCountry.CONGO]: 'Republik Kongo',
				[CompanyCountry.COSTA_RICA]: 'Costa Rica',
				[CompanyCountry.CROATIA]: 'Kroatien',
				[CompanyCountry.CUBA]: 'Kuba',
				[CompanyCountry.CYPRUS]: 'Zypern',
				[CompanyCountry.CZECH_REPUBLIC]: 'Tschechische Republik',
				[CompanyCountry.DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: 'Demokratische Republik des Kongo',
				[CompanyCountry.DENMARK]: 'Dänemark',
				[CompanyCountry.DJIBOUTI]: 'Dschibuti',
				[CompanyCountry.DOMINICA]: 'Dominica',
				[CompanyCountry.DOMINICAN_REPUBLIC]: 'Dominikanische Republik',
				[CompanyCountry.ECUADOR]: 'Ecuador',
				[CompanyCountry.EGYPT]: 'Ägypten',
				[CompanyCountry.EL_SALVADOR]: 'El Salvador',
				[CompanyCountry.EQUATORIAL_GUINEA]: 'Äquatorialguinea',
				[CompanyCountry.ERITREA]: 'Eritrea',
				[CompanyCountry.ESTONIA]: 'Estland',
				[CompanyCountry.ESWATINI]: 'Eswatini',
				[CompanyCountry.ETHIOPIA]: 'Äthiopien',
				[CompanyCountry.FIJI]: 'Fidschi',
				[CompanyCountry.FINLAND]: 'Finnland',
				[CompanyCountry.FRANCE]: 'Frankreich',
				[CompanyCountry.GABON]: 'Gabun',
				[CompanyCountry.GAMBIA]: 'Gambia',
				[CompanyCountry.GEORGIA]: 'Georgien',
				[CompanyCountry.GERMANY]: 'Deutschland',
				[CompanyCountry.GHANA]: 'Ghana',
				[CompanyCountry.GREECE]: 'Griechenland',
				[CompanyCountry.GRENADA]: 'Grenada',
				[CompanyCountry.GUATEMALA]: 'Guatemala',
				[CompanyCountry.GUINEA]: 'Guinea',
				[CompanyCountry.GUINEA_BISSAU]: 'Guinea-Bissau',
				[CompanyCountry.GUYANA]: 'Guyana',
				[CompanyCountry.HAITI]: 'Haiti',
				[CompanyCountry.HONDURAS]: 'Honduras',
				[CompanyCountry.HUNGARY]: 'Ungarn',
				[CompanyCountry.ICELAND]: 'Island',
				[CompanyCountry.INDIA]: 'Indien',
				[CompanyCountry.INDONESIA]: 'Indonesien',
				[CompanyCountry.IRAN]: 'Iran',
				[CompanyCountry.IRAQ]: 'Irak',
				[CompanyCountry.IRELAND]: 'Irland',
				[CompanyCountry.ISRAEL]: 'Israel',
				[CompanyCountry.ITALY]: 'Italien',
				[CompanyCountry.JAMAICA]: 'Jamaika',
				[CompanyCountry.JAPAN]: 'Japan',
				[CompanyCountry.JORDAN]: 'Jordanien',
				[CompanyCountry.KAZAKHSTAN]: 'Kasachstan',
				[CompanyCountry.KENYA]: 'Kenia',
				[CompanyCountry.KIRIBATI]: 'Kiribati',
				[CompanyCountry.KUWAIT]: 'Kuwait',
				[CompanyCountry.KYRGYZSTAN]: 'Kirgisistan',
				[CompanyCountry.LAOS]: 'Laos',
				[CompanyCountry.LATVIA]: 'Lettland',
				[CompanyCountry.LEBANON]: 'Libanon',
				[CompanyCountry.LESOTHO]: 'Lesotho',
				[CompanyCountry.LIBERIA]: 'Liberia',
				[CompanyCountry.LIBYA]: 'Libyen',
				[CompanyCountry.LIECHTENSTEIN]: 'Liechtenstein',
				[CompanyCountry.LITHUANIA]: 'Litauen',
				[CompanyCountry.LUXEMBOURG]: 'Luxemburg',
				[CompanyCountry.MADAGASCAR]: 'Madagaskar',
				[CompanyCountry.MALAWI]: 'Malawi',
				[CompanyCountry.MALAYSIA]: 'Malaysia',
				[CompanyCountry.MALDIVES]: 'Malediven',
				[CompanyCountry.MALI]: 'Mali',
				[CompanyCountry.MALTA]: 'Malta',
				[CompanyCountry.MARSHALL_ISLANDS]: 'Marshallinseln',
				[CompanyCountry.MAURITANIA]: 'Mauretanien',
				[CompanyCountry.MAURITIUS]: 'Mauritius',
				[CompanyCountry.MEXICO]: 'Mexiko',
				[CompanyCountry.MICRONESIA]: 'Mikronesien',
				[CompanyCountry.MOLDOVA]: 'Moldau',
				[CompanyCountry.MONACO]: 'Monaco',
				[CompanyCountry.MONGOLIA]: 'Mongolei',
				[CompanyCountry.MONTENEGRO]: 'Montenegro',
				[CompanyCountry.MOROCCO]: 'Marokko',
				[CompanyCountry.MOZAMBIQUE]: 'Mosambik',
				[CompanyCountry.MYANMAR]: 'Myanmar',
				[CompanyCountry.NAMIBIA]: 'Namibia',
				[CompanyCountry.NAURU]: 'Nauru',
				[CompanyCountry.NEPAL]: 'Nepal',
				[CompanyCountry.NETHERLANDS]: 'Niederlande',
				[CompanyCountry.NEW_ZEALAND]: 'Neuseeland',
				[CompanyCountry.NICARAGUA]: 'Nicaragua',
				[CompanyCountry.NIGER]: 'Niger',
				[CompanyCountry.NIGERIA]: 'Nigeria',
				[CompanyCountry.NORTH_KOREA]: 'Nordkorea',
				[CompanyCountry.NORTH_MACEDONIA]: 'Nordmazedonien',
				[CompanyCountry.NORWAY]: 'Norwegen',
				[CompanyCountry.OMAN]: 'Oman',
				[CompanyCountry.PAKISTAN]: 'Pakistan',
				[CompanyCountry.PALAU]: 'Palau',
				[CompanyCountry.PALESTINE]: 'Palästina',
				[CompanyCountry.PANAMA]: 'Panama',
				[CompanyCountry.PAPUA_NEW_GUINEA]: 'Papua-Neuguinea',
				[CompanyCountry.PARAGUAY]: 'Paraguay',
				[CompanyCountry.PERU]: 'Peru',
				[CompanyCountry.PHILIPPINES]: 'Philippinen',
				[CompanyCountry.POLAND]: 'Polen',
				[CompanyCountry.PORTUGAL]: 'Portugal',
				[CompanyCountry.QATAR]: 'Katar',
				[CompanyCountry.ROMANIA]: 'Rumänien',
				[CompanyCountry.RUSSIA]: 'Russland',
				[CompanyCountry.RWANDA]: 'Ruanda',
				[CompanyCountry.SAINT_KITTS_AND_NEVIS]: 'St. Kitts und Nevis',
				[CompanyCountry.SAINT_LUCIA]: 'St. Lucia',
				[CompanyCountry.SAINT_VINCENT_AND_THE_GRENADINES]: 'St. Vincent und die Grenadinen',
				[CompanyCountry.SAMOA]: 'Samoa',
				[CompanyCountry.SAN_MARINO]: 'San Marino',
				[CompanyCountry.SAO_TOME_AND_PRINCIPE]: 'São Tomé und Príncipe',
				[CompanyCountry.SAUDI_ARABIA]: 'Saudi-Arabien',
				[CompanyCountry.SENEGAL]: 'Senegal',
				[CompanyCountry.SERBIA]: 'Serbien',
				[CompanyCountry.SEYCHELLES]: 'Seychellen',
				[CompanyCountry.SIERRA_LEONE]: 'Sierra Leone',
				[CompanyCountry.SINGAPORE]: 'Singapur',
				[CompanyCountry.SLOVAKIA]: 'Slowakei',
				[CompanyCountry.SLOVENIA]: 'Slowenien',
				[CompanyCountry.SOLOMON_ISLANDS]: 'Salomonen',
				[CompanyCountry.SOMALIA]: 'Somalia',
				[CompanyCountry.SOUTH_AFRICA]: 'Südafrika',
				[CompanyCountry.SOUTH_KOREA]: 'Südkorea',
				[CompanyCountry.SOUTH_SUDAN]: 'Südsudan',
				[CompanyCountry.SPAIN]: 'Spanien',
				[CompanyCountry.SRI_LANKA]: 'Sri Lanka',
				[CompanyCountry.SUDAN]: 'Sudan',
				[CompanyCountry.SURINAME]: 'Suriname',
				[CompanyCountry.SWEDEN]: 'Schweden',
				[CompanyCountry.SWITZERLAND]: 'Schweiz',
				[CompanyCountry.SYRIA]: 'Syrien',
				[CompanyCountry.TAIWAN]: 'Taiwan',
				[CompanyCountry.TAJIKISTAN]: 'Tadschikistan',
				[CompanyCountry.TANZANIA]: 'Tansania',
				[CompanyCountry.THAILAND]: 'Thailand',
				[CompanyCountry.TIMOR_LESTE]: 'Osttimor',
				[CompanyCountry.TOGO]: 'Togo',
				[CompanyCountry.TONGA]: 'Tonga',
				[CompanyCountry.TRINIDAD_AND_TOBAGO]: 'Trinidad und Tobago',
				[CompanyCountry.TUNISIA]: 'Tunesien',
				[CompanyCountry.TURKEY]: 'Türkei',
				[CompanyCountry.TURKMENISTAN]: 'Turkmenistan',
				[CompanyCountry.TUVALU]: 'Tuvalu',
				[CompanyCountry.UGANDA]: 'Uganda',
				[CompanyCountry.UKRAINE]: 'Ukraine',
				[CompanyCountry.UNITED_ARAB_EMIRATES]: 'Vereinigte Arabische Emirate',
				[CompanyCountry.UNITED_KINGDOM]: 'Vereinigtes Königreich',
				[CompanyCountry.UNITED_STATES_OF_AMERICA]: 'Vereinigte Staaten von Amerika',
				[CompanyCountry.URUGUAY]: 'Uruguay',
				[CompanyCountry.UZBEKISTAN]: 'Usbekistan',
				[CompanyCountry.VANUATU]: 'Vanuatu',
				[CompanyCountry.VATICAN_CITY]: 'Vatikanstadt',
				[CompanyCountry.VENEZUELA]: 'Venezuela',
				[CompanyCountry.VIETNAM]: 'Vietnam',
				[CompanyCountry.YEMEN]: 'Jemen',
				[CompanyCountry.ZAMBIA]: 'Sambia',
				[CompanyCountry.ZIMBABWE]: 'Simbabwe'
			},
			companyType: {
				[CompanyType.DISTRIBUTOR]: 'Händler',
				[CompanyType.DIVISION]: 'Division',
				[CompanyType.END_USER]: 'Endanwender',
				[CompanyType.SALES_COMPANY]: 'Sales Co'
			},
			status: {
				[Status.ACTIVE]: 'Aktiv',
				[Status.INACTIVE]: 'Inaktiv',
				[Status.DELETED]: 'Gelöscht'
			}
		},
		errorPages: {
			forbidden: {
				code: '403',
				message: 'Zugriff verweigert',
				explanation: 'Die von Ihnen gesuchte Seite ist nicht zugänglich.'
			},
			notFound: {
				code: '404',
				message: 'Seite nicht gefunden',
				explanation: 'Die von Ihnen gesuchte Seite existiert nicht oder ist derzeit nicht verfügbar.'
			},
			unauthorized: {
				code: '401',
				message: 'Nicht autorisiert',
				explanation: 'Sie sind nicht berechtigt, auf die angeforderte Seite zuzugreifen.'
			}
		},
		errors: {
			certificationAlreadyCreated: 'Zertifizierung bereits für diesen Lernenden erstellt',
			emailAlreadyUsed: 'E-Mail bereits verwendet. Sie muss eindeutig sein',
			occurred: 'Ein Fehler ist aufgetreten',
			pattern: 'Falsches Format',
			required: 'Pflichtfeld',
			traineeHasNoEmail: 'Ein Trainer muss eine E-Mail-Adresse haben'
		},
		fields: {
			company: 'Unternehmen',
			country: 'Land',
			course: 'Kurs',
			email: 'E-Mail',
			firstname: 'Vorname',
			lastname: 'Nachname',
			name: 'Name',
			status: 'Status',
			trainer: 'Trainer',
			type: 'Kategorie'
		},
		lang: LANGUAGE,
		tabs: {
			[Route.DASHBOARD]: 'SBEx-Dashboard',
			[Route.TRAINEES]: 'Verwaltung der SBEx-Lernenden',
			[Route.ANALYTICS]: 'SBEx analytics'
		}
	},
	components: {
		certificationPopIn: {
			creation: {
				title: 'Neue Zertifizierung',
				subtitle: 'Geben Sie die Schulungsdetails ein, um die Zertifizierung zu erstellen.',
				buttons: {
					confirm: {
						label: 'Zertifizierung erstellen'
					}
				},
				success: 'Die Zertifizierung wurde erstellt'
			},
			fields: {
				trainer: {
					placeholder: 'Einen Trainer auswählen',
					noData: 'Kein aktiver Trainer'
				},
				course: {
					placeholder: 'Einen Kurs auswählen'
				},
				isTrainer: {
					label: 'Als Trainer erhalten'
				},
				date: {
					label: 'Schulungsdatum',
					placeholder: 'Ein Datum auswählen'
				}
			}
		}
	},
	dashboard: {
		expiringCertifications: {
			title: '<a><b>{count} ablaufende {count, plural, =0 {Zertifizierung} one {Zertifizierung} other {Zertifizierungen}}</b><c>(in 3 Monaten oder weniger)</c></a>',
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				trainer: 'Trainer',
				date: 'Läuft ab am {date}',
				discardButton: {
					label: 'Löschen',
					success: 'Die Benachrichtigung wurde gelöscht'
				},
				noData: 'Keine ablaufenden Zertifizierungen'
			}
		},
		trainees: {
			title: 'Verwaltung der Lernenden',
			actions: {
				addTrainee: {
					label: 'Neuer Lernender',
					title: 'Neuer Lernender',
					subtitle: 'Fügen Sie einen Lernenden hinzu, damit Sie ihm eine Zertifizierung ausstellen können.',
					fields: {
						email: {
							label: 'E-Mail (erforderlich für Trainer)'
						},
						company: {
							placeholder: 'Unternehmen auswählen'
						}
					},
					buttons: {
						create: 'Einen Lernenden erstellen',
						createWithCertification: 'Einen Lernenden erstellen und eine Zertifizierung hinzufügen'
					},
					success: 'Der Lernende wurde erstellt'
				},
				addCompany: {
					title: 'Unternehmen auswählen',
					subtitle: 'Suchen Sie das Unternehmen des Lernenden oder fügen Sie es hinzu, wenn es nicht aufgeführt ist.',
					filters: {
						query: {
							placeholder: 'Geben Sie den Namen eines Unternehmens ein.'
						}
					},
					links: {
						createCompany: '<a><b>Das Unternehmen existiert nicht?</b> <c><b>Klicken Sie hier, um es zu erstellen</b></c></a>'
					},
					noData: 'Kein Unternehmen'
				},
				createCompany: {
					title: 'Neues Unternehmen',
					subtitle: 'Erstellen Sie ein neues Unternehmen, das für die Erstellung von Lernenden verwendet werden soll.',
					fields: {
						type: {
							placeholder: 'Kategorie des Unternehmens auswählen'
						},
						country: {
							placeholder: 'Ein Land auswählen'
						},
						name: {
							placeholder: 'Name des Unternehmens'
						}
					},
					buttons: {
						confirm: {
							label: 'Unternehmen erstellen'
						}
					},
					success: 'Das Unternehmen wurde erstellt'
				}
			},
			filters: {
				company: 'Unternehmen auswählen',
				companiesNotFound: 'Kein Unternehmen gefunden',
				query: 'Name, E-Mail oder Zertifikatsnummer',
				advanced: {
					title: 'Erweiterte Filter',
					subtitle: 'Filtern Sie Zertifizierungen nach Schulung und/oder Datumsbereich.',
					course: {
						title: 'Schulung',
						select: 'Schulung auswählen'
					},
					startDate: 'Schulungsdatum ab',
					endDate: 'bis'
				}
			},
			list: {
				trainee: '<a><b>{name}</b> <c>/</c> <c>{company}</c></a>',
				actions: {
					viewUpdate: {
						label: 'Anzeigen und aktualisieren'
					},
					addCertification: {
						label: 'Eine Zertifizierung hinzufügen'
					}
				},
				noData: 'Kein Lernender'
			}
		},
		tooltips: {
			viewTraineeDetails: 'Verwenden Sie STRG+Klick, um die Details des Lernenden in einem neuen Tab zu öffnen'
		}
	},
	trainee: {
		information: {
			buttons: {
				save: {
					label: 'Änderungen speichern',
					success: 'Die Informationen des Lernenden wurden gespeichert'
				},
				delete: {
					title: 'Lernenden löschen',
					message: 'Löschen des Lernenden bestätigen?',
					success: 'Der Lernende wurde gelöscht'
				}
			}
		},
		certifications: {
			header: {
				title: 'Zertifizierungen'
			},
			actions: {
				create: {
					label: 'Neue Zertifizierung'
				},
				update: {
					title: 'Zertifizierung bearbeiten',
					subtitle: 'Prüfen und bearbeiten Sie die Informationen, bevor Sie die Zertifizierung generieren.',
					buttons: {
						confirm: {
							label: 'Änderungen speichern'
						}
					},
					success: 'Die Zertifizierung wurde aktualisiert'
				},
				delete: {
					title: 'Zertifizierung löschen',
					message: 'Löschen der Zertifizierung bestätigen?',
					success: 'Die Zertifizierung wurde gelöscht'
				}
			},
			list: {
				trainer: 'Trainer',
				training: 'Geschult am {date} durch {trainer} / {company}',
				expiringDate: 'Läuft ab am {date}',
				noData: 'Keine Zertifizierung',
				download: {
					label: 'Zertifikat herunterladen'
				}
			}
		}
	},
	analytics: {
		title: 'Analysedaten',
		inputs: {
			startDate: {
				label: 'Auswahl des Startdatums'
			},
			endDate: {
				label: 'Auswahl des Enddatums'
			}
		}
	}
}

const appMessages: Record<string, string> = flatten(messages)

export default appMessages
